import React from 'react';
import Countdown from 'react-countdown';
import { useSelector } from 'react-redux';

const DashboardBoxDelivery = ({ data }) => {

    const detailItem = data.tmbeList;

    const title = detailItem.filter((state) => state.acMenuBlockElement === 'title');
    const subtitle = detailItem.filter((state) => state.acMenuBlockElement === 'subtitle');
    const date = detailItem.filter((state) => state.acMenuBlockElement === 'date');
    const shortDescription = detailItem.filter((state) => state.acMenuBlockElement === 'shortDescription');
    const adDeliveryDays = useSelector((state) => state.getB2bSettings.items.adDeliveryDays);

    if (!date[0]?.acMenuBlockElementValue) {
        return null;
    }

    const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const today = new Date();
    const countdown = date[0].acMenuBlockElementValue.split(':');
    const countdownHour = parseInt(countdown[0], 10);
    const countdownMinutes = parseInt(countdown[1], 10);

    const currentDay = today.getDay();
    const currentHour = today.getHours();
    const currentMinutes = today.getMinutes();

    let minDaysDifference = 7;

    adDeliveryDays.forEach(day => {
        const dayIndex = daysOfWeek.indexOf(day);
        let daysDifference = (dayIndex - currentDay + 7) % 7;

        if (daysDifference === 0 && (currentHour > countdownHour || (currentHour === countdownHour && currentMinutes >= countdownMinutes))) {
            daysDifference = 7;
        }

        if (daysDifference < minDaysDifference) {
            minDaysDifference = daysDifference;
        }
    });

    const targetDate = new Date(today);
    targetDate.setDate(today.getDate() + minDaysDifference);
    targetDate.setHours(countdownHour, countdownMinutes, 0, 0);

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return <div>00:00:00</div>;
        } else {
            return (
                <div>
                    {days > 0 ? `${days}D ` : ""}
                    {hours < 10 ? '0' + hours : hours}:
                    {minutes < 10 ? '0' + minutes : minutes}:
                    {seconds < 10 ? '0' + seconds : seconds}
                </div>
            );
        }
    };

    return (
        <div className="dashboard-box-delivery">
            {title[0]?.acMenuBlockElementValue && (
                <div className="dashboard-box-deliver-title" style={{ borderBottom: `1px solid ${data.acMenuBlockColor}` }}>
                    {title[0]?.acMenuBlockElementValue}
                </div>
            )}
            {subtitle[0]?.acMenuBlockElementValue && (
                <div className="dashboard-box-deliver-subtitle">
                    {subtitle[0]?.acMenuBlockElementValue}
                </div>
            )}
            <div className="dashboard-box-deliver-value">
                <Countdown date={targetDate} renderer={renderer} />
            </div>
            {shortDescription[0]?.acMenuBlockElementValue && (
                <div className="dashboard-box-deliver-info-text">
                    {shortDescription[0]?.acMenuBlockElementValue}
                </div>
            )}
        </div>
    );
};

export default DashboardBoxDelivery;